import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, Input } from '@hb/coffee';
import { trimAll, trimValue } from '@/shared/utils/trim';
import { InfoComplementField } from '@/components/new-info-complete/types';
import { idCardRegExp } from '@/shared/utils/RegExpConsts';

@Component({ name: 'IdCardNo' })
export default class IdCardNo extends Vue implements InfoComplementField {
  @Prop()
  private value!: string;

  private idCardNo = '';

  private errorMsg = '';

  public onValidator(): boolean {
    const val = this.idCardNo;

    if (val === undefined || val === null || val === '') {
      this.errorMsg = '请填写身份证号';
      return false;
    }

    if (!idCardRegExp.test(trimValue(val))) {
      this.errorMsg = '请填写正确的身份证号';
      return false;
    }

    return true;
  }

  private created() {
    if (this.value) {
      this.idCardNo = this.value;
    }
  }

  @Watch('value')
  private onPropsValueChange(val: string) {
    /** 删除空格字符 */
    this.idCardNo = trimAll(val);
  }

  private onChangeName(val: string) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private onFocus() {
    this.$emit('focus');
  }

  private onBlur() {
    this.onValidator();
    this.$emit('blur');
  }

  /**
   * 格式化身份证号
   * 服务端要求字符"x"要大写
   */
  private formatIdCardNo(val: string) {
    return trimAll(val).toUpperCase();
  }

  private render() {
    return (
      <Field
        label="身份证号"
        errorMessage={this.errorMsg}
      >
        <Input
          v-model={this.idCardNo}
          placeholder="请填写身份证号"
          formatter={this.formatIdCardNo}
          on={{
            'update:modelValue': (val: string) => {
              this.onChangeName(val);
            },
          }}
          onFocus={this.onFocus.bind(this)}
          onBlur={this.onBlur.bind(this)}
        />
      </Field>
    );
  }
}
